



















import thai from '@/assets/images/thailand.png';
import usa from '@/assets/images/usa.png';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class LanguageButton extends Vue {
  localeList = [
    {
      name: 'ไทย',
      value: 'th',
      pic: thai,
    },
    {
      name: 'English',
      value: 'en',
      pic: usa,
    },
  ];

  currentLocale: any = this.localeList[0];

  created() {
    this.setCurrentLocale();
  }

  handleLocale(value) {
    this.$i18n.locale = value;
    this.setCurrentLocale();
  }

  setCurrentLocale() {
    this.currentLocale = this.localeList.find((item) => item.value === this.$i18n.locale);
  }
}
